module.exports = __webpack_public_path__ + "img/Metastasis-OPSCC_PMID37704757.59b982e8.png";